<template>
    <div :class="['loader', { 'spinner-wrap' : props.isFixed }]" :style="style">
        <div class="dot"></div>
        <div class="dot"></div>
        <div class="dot"></div>
    </div>

</template>

<script setup>
import { defineProps } from "vue";

const props = defineProps({
    style: Object,
    isFixed: {
        type: Boolean,
        default: false 
    },
});

</script>
<style lang="scss" scoped>
@import "@/assets/scss/components/common/spinner.scss";
</style>